import { Button, Checkbox, FormControl, FormControlLabel, Grid, InputLabel, MenuItem, Select, TextareaAutosize, TextField } from '@mui/material';
import React from 'react'
import { Create } from 'react-admin';
import { useNavigate } from "react-router-dom";
import { CuisineDishService } from '../../services/CuisineDishService';
import EventBus from '../../EventBus';
import { EventBusEventsEnum } from '../../enums/EventBusEventsEnum';
import { CustomSnackbarTypes } from '../Common/CustomSnackBar';


let cuisineDishService = new CuisineDishService();
function CreateCusineDish() {
    const navigate = useNavigate();

    let[name, setName] = React.useState<string>("");
    let[nameHi, setNameHi] = React.useState<string>("");
    let[nameBn, setNameBn] = React.useState<string>("");
    let[categoryId, setCategoryId] = React.useState<number>(0);
    let[mealType, setMealType] = React.useState<string>("");
    let[type, setType] = React.useState<string>("");
    let[description, setDescription] = React.useState<string>("");
    let[forChefit, setForChefit] = React.useState<boolean>(false);
    let[forParty, setForParty] = React.useState<boolean>(false);
    let[dishType, setDishType] = React.useState<string>("");
    let[filterCategory, setFilterCategory] = React.useState<string>("");
    let[categories, setCategories] = React.useState<any>([]);
    let[categoryTags, setCategoryTags] = React.useState<any>([]);
    let[selectedTagIds, setSelectedTagIds] = React.useState<number[]>([]);


    React.useEffect(() => {
        getCategories();
        getCategoryTags();
    }, []);


    let getCategories = async() => {
        let data = await cuisineDishService.getDishCategories();
        if (data) {
            setCategories(data);
        } else {
            console.error("Failed to fetch categories");
        }
    }

    let getCategoryTags = async() => {
        let data = await cuisineDishService.getCategoryTags();
        if (data) {
            setCategoryTags(data);
        } else {
            console.error("Failed to fetch category tags");
        }
    }

    let getSelectedTagNames = (selectedIds: number[]) => {
        return selectedIds
            .map((id: number) => categoryTags.find((tag: any) => tag?.id === id)?.name)
            .filter((name: string) => Boolean(name))
            .join(", ");
    }

    let createCuisineDish = async () => {
        if (!name || !categoryId || !mealType) {
            EventBus.emitEvent(EventBusEventsEnum.SNACKBAR_SHOW, {
                message: "Please fill all the required fields",
                type: CustomSnackbarTypes.ERROR,
            });
        }
        let payload:any = {
            name,
            categoryId,
            mealType,
            forChefit,
            forParty,
            categoryTagIds: selectedTagIds,
        };
        if (nameHi) {
            payload["nameHi"] = nameHi;
        }
        if (nameBn) {
            payload["nameBn"] = nameBn;
        }
        if (type) {
            payload["type"] = type;
        }
        if (description) {
            payload["description"] = description;
        }
        if (dishType) {
            payload["dishType"] = dishType;
        }
        if (filterCategory) {
            payload["filterCategory"] = filterCategory;
        }
        try {
            let data = await cuisineDishService.createCuisineDish(payload);
            EventBus.emitEvent(EventBusEventsEnum.SNACKBAR_SHOW, {
                message: "Created Successfully",
                type: CustomSnackbarTypes.SUCCESS,
            });
            navigate(`/CuisineDish/${data?.id}/show`);
        } catch (error) {
            EventBus.emitEvent(EventBusEventsEnum.SNACKBAR_SHOW, {
                message: "Failed to create Cuisine Dish",
                type: CustomSnackbarTypes.ERROR,
            });
        }
    }
  
    return (
      <Create title={"Create Coupon"}>
        <Grid container columns={1} rowSpacing={1} style={{ padding: "12px" }}>
        <Grid item xs={4}>
          <FormControl style={{ width: "230px" }}>
            <TextField
              label="Name"
              value={name}
              type="text"
              onChange={(event: any) => {
                setName(event.target.value);
              }}
            />
          </FormControl>
        </Grid>
        <Grid item xs={4}>
          <FormControl style={{ width: "230px" }}>
            <TextField
              label="Name in Hindi"
              value={nameHi}
              type="text"
              onChange={(event: any) => {
                setNameHi(event.target.value);
              }}
            />
          </FormControl>
        </Grid>
        <Grid item xs={4}>
          <FormControl style={{ width: "230px" }}>
            <TextField
              label="Name in Bengali"
              value={nameBn}
              type="text"
              onChange={(event: any) => {
                setNameBn(event.target.value);
              }}
            />
          </FormControl>
        </Grid> 
        <Grid item xs={4}>
          <FormControl style={{ width: "230px" }}>
            <InputLabel id="categoryType">Category</InputLabel>
            <Select
              labelId="categoryType"
              value={categoryId}
              label="Category"
              onChange={(event: any) => {
                setCategoryId(event.target.value);
              }}
            >
              {categories.map((e: any) => (
                <MenuItem key={e?.name} value={e?.id}>
                  {e?.name}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Grid> 
        <Grid item xs={4}>
          <FormControl style={{ width: "230px" }}>
            <InputLabel id="mealType">Meal Type</InputLabel>
            <Select
              labelId="mealType"
              value={mealType}
              label="Meal Type"
              onChange={(event: any) => {
                setMealType(event.target.value);
              }}
            >
              {["STARTER", "MAIN COURSE", "DESSERT", "SIDE_DISH", "BEVERAGE"].map((e: any) => (
                <MenuItem key={e} value={e}>
                  {e}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Grid>
        <Grid item xs={4}>
          <FormControl style={{ width: "230px" }}>
            <InputLabel id="type">Type</InputLabel>
            <Select
              labelId="type"
              value={type}
              label="Type"
              onChange={(event: any) => {
                setType(event.target.value);
              }}
            >
              {["VEG", "NON_VEG", "ANY"].map((e: any) => (
                <MenuItem key={e} value={e}>
                  {e}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Grid> 
        <Grid item xs={4}>
          <FormControlLabel
            control={
              <Checkbox
                checked={forChefit}
                onChange={(e) => {
                  setForChefit(e.target.checked);
                }}
                name="For Chefit"
              />
            }
            label="For Chefit"
          />
        </Grid>
        <Grid item xs={4}>
          <FormControlLabel
            control={
              <Checkbox
                checked={forParty}
                onChange={(e) => {
                  setForParty(e.target.checked);
                }}
                name="For Party"
              />
            }
            label="For Party"
          />
        </Grid>  
        <Grid item xs={4}>
          <FormControl style={{ width: "230px" }}>
          <TextareaAutosize
              placeholder="Description"
              value={description}
              minRows={3}
              maxRows={3}
              onChange={(event: any) => {
                setDescription(event.target.value);
              }}
            />
          </FormControl>
        </Grid>  
        <Grid item xs={4}>
        <FormControl style={{ width: "230px" }}>
            <InputLabel id="dishtype">Dish Type</InputLabel>
            <Select
              labelId="dishtype"
              value={dishType}
              label="Dish Type"
              onChange={(event: any) => {
                setDishType(event.target.value);
              }}
            >
              {['BREAD','CURRY'].map((e: any) => (
                <MenuItem key={e} value={e}>
                  {e}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Grid>
        <Grid item xs={4}>
          <FormControl style={{ width: "230px" }}>
            <TextField
              label="Filter Category"
              value={filterCategory}
              type="text"
              onChange={(event: any) => {
                setFilterCategory(event.target.value);
              }}
            />
          </FormControl>
        </Grid>
        <Grid item xs={4}>
          <FormControl style={{ width: "230px" }}>
            <InputLabel id="categoryTags">Category Tags</InputLabel>
            <Select
              multiple
              labelId="categoryTags"
              value={selectedTagIds}
              label="Category Tags"
              renderValue={(selected: any) => getSelectedTagNames(selected as number[])}
              onChange={(event: any) => {
                const value = event.target.value;
                setSelectedTagIds(
                  Array.isArray(value) ? value.map((id: any) => Number(id)) : []
                );
              }}
            >
              {categoryTags.map((tag: any) => (
                <MenuItem key={tag?.id} value={tag?.id}>
                  <Checkbox checked={selectedTagIds.includes(tag?.id)} />
                  {tag?.name}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Grid>
        <Grid item xs={12}>
          <FormControl style={{ width: "230px" }}>
            <Button
              onClick={createCuisineDish}
              variant="contained"
            >
              Create Cuisine Dish
            </Button>
          </FormControl> 
          </Grid>  
    </Grid>
      </Create>
    );
  };

export default CreateCusineDish
